import React from 'react';
import { Img, Neon } from '../../components';
import { Content, Description, FeaturedImg, Wrapper } from './Bio.styled';

export default function Bio({ data }) {
	const { title, description } = data.site.siteMetadata;

	return (
		<Wrapper>
			<Neon as="h1" color="green">
				About
			</Neon>
			<Content className="card">
				<Description>{description}</Description>
				{data?.actionImage?.childImageSharp?.gatsbyImageData && (
					<FeaturedImg>
						<Img
							src={
								data.actionImage.childImageSharp.gatsbyImageData
							}
							alt={title}
						/>
						<div className="overlay"></div>
					</FeaturedImg>
				)}
			</Content>
		</Wrapper>
	);
}
